import styled from "styled-components";

const StyledAppContainer = styled.section`
    display: flex;
    position: relative;
`;

const StyledPageContainer = styled.section`
    box-sizing: border-box;
    width: 100%;
    flex: 1 1 0%;
    overflow: hidden auto;
    padding: 80px 34px 34px 34px;
`;

export { StyledAppContainer, StyledPageContainer };
